import { popoverUniDriverFactory } from '../../Popover/Popover.uni.driver';

export const closablePopoverUniDriverFactory = (base, body) => {
  const popoverDriver = popoverUniDriverFactory(base, body);

  return {
    ...popoverUniDriverFactory(base, body),

    /**
     * Checks whether the popover's content is open
     * @return {Promise<boolean>}
     */
    isOpened: () => popoverDriver.isContentElementExists(),
  };
};
